import {
  FILTER_DATA_SOURCE_TYPE_KEY,
  FILTER_POLICY_TYPE,
  IS_UNRESOLVED,
  PAGE_VIEW_KEY,
  PAGE_VIEW_VALUES,
  POLICY_TYPES_MAPPER,
  POLICY_TYPES_MAPPER_COMPACT,
  URL_ALERTS,
  URL_POLICIES
} from '../../../../constants'
import { getUpdatedUrl } from '../../../../utils/urlUtil'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import React from 'react'
import { Typography } from '@lightbeamai/design-system'

interface IProps {
  policy: { policyType: string; alertsCount: number }
  datasourceType?: string
}

const PolicyItem = (props: IProps): React.ReactElement => {
  const {
    policy: { policyType = '', alertsCount },
    datasourceType = ''
  } = props
  const intl = useIntl()

  return (
    <div>
      <Link
        target="_blank"
        // TODO policy filter inside alerts list is not working
        to={getUpdatedUrl({
          pathName: URL_POLICIES + URL_ALERTS,
          pageName: URL_ALERTS,
          pageQueryParams: {
            [PAGE_VIEW_KEY]: PAGE_VIEW_VALUES.list,
            [FILTER_POLICY_TYPE]: policyType,
            [IS_UNRESOLVED]: true,
            ...(datasourceType && { [FILTER_DATA_SOURCE_TYPE_KEY]: datasourceType })
          },
          resetQuery: true
        })}
        data-test-id="dashboard-policy-item"
        className="policy-item card-sub-item"
      >
        <div>
          <div
            className="description truncate"
            title={
              POLICY_TYPES_MAPPER_COMPACT[policyType]
                ? intl.formatMessage({ id: POLICY_TYPES_MAPPER_COMPACT[policyType] })
                : ''
            }
          >
            <Typography color="primary" type="medium" variant="baseMinus2">
              {POLICY_TYPES_MAPPER_COMPACT[policyType]
                ? intl.formatMessage({ id: POLICY_TYPES_MAPPER_COMPACT[policyType] }) + ': '
                : ''}

              {POLICY_TYPES_MAPPER[policyType]
                ? intl.formatMessage({ id: POLICY_TYPES_MAPPER[policyType] })
                : ''}
            </Typography>
            {/* <Typography color="primary" type="medium" variant="baseMinus2">
              {POLICY_TYPES_MAPPER[name]
                ? intl.formatMessage({ id: POLICY_TYPES_MAPPER[name] })
                : ''}
            </Typography> */}
          </div>
          {/* <div
            className="name truncate"
            title={
              POLICY_TYPES_MAPPER[name] ? intl.formatMessage({ id: POLICY_TYPES_MAPPER[name] }) : ''
            }
          ></div> */}
        </div>
        <div>
          <Typography className="xs-mb-0 count" color="primary" type="strong" variant="basePlus2">
            {intl.formatNumber(alertsCount, { notation: 'compact' })}
          </Typography>
          <div className="at-risk-text">
            <Typography className="risk-text" color="primary" type="strong" variant="baseMinus2">
              {intl.formatMessage({ id: 'alerts' })}
            </Typography>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default PolicyItem
